import Head from 'next/head';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Navigation from '../components/Navigation/Navigation';
import PageWrapper from '../components/PageWrapper/PageWrapper';

import Subprocessors from '../components/Subprocessors/Subprocessors';

const SubprocessorsPage = () => (
  <>
    <Head>
      <title>Subprocessors - Mutiny | Turn Your Website Into Your #1 Growth Channel</title>
    </Head>
    <PageWrapper modifier="PageWrapper--frostBlue">
      <Navigation />
      <Header title={['List of Subprocessors']} goBackButton />
      <Subprocessors />
      <Footer />
    </PageWrapper>
  </>
);

export default SubprocessorsPage;
